/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */

import { Button, VStack } from '@chakra-ui/react';
import { UserMCQComponent } from '@karya/core';
import { ParsedParams } from '@karya/generic-task-react';
import { ButtonVariant } from '@/themes/ButtonVariants';
import { ComponentRendererProps } from '../ComponentRenderer';

export function UserMCQRenderer(props: ComponentRendererProps) {
  const typedParams = props.node.params as ParsedParams<UserMCQComponent>;
  const component = props.node.component as UserMCQComponent;
  const selected = typedParams.selected;

  const options = typedParams.options ?? ['Option A', 'Option B', 'Option C'];

  const handleToggleOption = (opt: string) => {
    if (!props.isCurrent) {
      return;
    }

    const selectedSet = new Set(selected);
    if (selectedSet.has(opt)) {
      selectedSet.delete(opt);
    } else {
      selectedSet.add(opt);
    }
    props.writeOutput(component.selected, Array.from(selectedSet));
  };

  return (
    <VStack spacing="3px" width="150px" alignItems="stretch">
      {options.map((option, index) => (
        <Button
          key={index}
          variant={selected?.includes(option) ? ButtonVariant.secondary : ButtonVariant.secondary_outlined}
          onClick={() => handleToggleOption(option)}
        >
          {option}
        </Button>
      ))}
    </VStack>
  );
}
